<template>
    <ul class="w-full">
        <!-- list of PROGRAMS -->
        <li
            v-for="(sourcePointsProgram, index) in sourceProgramUserPoints"
            :key="index"
        >
            <div
                class="w-full h-auto justify-start items-start flex flex-row gap-1 @3xl:flex-col @3xl:gap-4"
            >
                <!-- Sublist of USERS for this PROGRAM -->
                <!-- START SINGLE TRANSFER OPTION -->
                <PointsCard
                    v-for="user in sourcePointsProgram.points"
                    :destinationProgramName="programName"
                    :destinationProgramImage="programImage"
                    :hasEnoughProgramPoints="user.hasEnoughProgramPoints"
                    :isTransfer="true"
                    :sourceProgram="sourcePointsProgram"
                    :user="user"
                    :usersCount="sourcePointsProgram.points.length"
                    :key="user.id"
                />
                <!-- END SINGLE TRANSFER OPTION -->
                <!-- END SUBLIST OF USERS -->
            </div>
            <!-- start brand logo -->
            <div
                class="self-stretch h-12 pt-6 flex-col justify-start items-start gap-2.5 flex"
            >
                <img :src="'/' + sourcePointsProgram.image" class="h-full" />
            </div>
            <!-- end brand logo -->
            <!-- start bonus info -->
            <div
                class="self-stretch h-7 pt-2 flex-col justify-start items-start gap-2.5 flex"
                v-if="
                    sourcePointsProgram.bonusRateFrom &&
                    bonusIsActive(
                        sourcePointsProgram.bonusStart,
                        sourcePointsProgram.bonusExpiration
                    )
                "
            >
                <div
                    class="px-3 py-0.5 bg-orange-50 rounded-[999px] justify-center items-center gap-2.5 inline-flex"
                >
                    <div
                        class="text-orange-600 text-xs font-medium leading-none"
                    >
                        {{
                            $filters.bonusTransferAsPercentage(
                                sourcePointsProgram.transferRateTo /
                                    sourcePointsProgram.transferRateFrom,
                                sourcePointsProgram.bonusRateTo /
                                    sourcePointsProgram.bonusRateFrom
                            )
                        }}
                        Transfer Bonus until
                        {{
                            $filters.formatShortDate(
                                sourcePointsProgram.bonusExpiration
                            )
                        }}
                    </div>
                </div>
            </div>
            <!-- end bonus info -->
            <!--
                SUPPORT-708 (F-034): the "View transfer details" modal that
                rendered `transfer_instructions` as raw HTML via `v-html` has
                been removed. Production held 197 rows with NULL
                transfer_instructions across the board, no admin ever authored
                a legacy iframe, and the frontend route that would have fed
                the modal (`/api/transfer-partners/type/hotel`) is not
                registered. Removing the sink closes the XSS surface without
                changing any user-visible behavior.
            -->
            <div
                class="w-[304px] h-[65px] py-8 flex-col justify-start items-start inline-flex"
                v-if="index < sourceProgramUserPoints.length - 1"
            >
                <div
                    class="self-stretch h-px bg-gradient-to-r from-slate-200 via-slate-200 to-slate-200"
                ></div>
            </div>
        </li>
    </ul>
</template>
<script>
import dayjs from 'dayjs';
import PointsCard from '@/components/hotels/property/points-card/points-card.vue';

export default {
    components: {
        PointsCard,
    },
    props: {
        programName: String,
        programImage: String,
        sourceProgramUserPoints: Array,
    },
    setup() {
        const bonusIsActive = (startDate, endDate) => {
            const today = dayjs();

            const beginDate = dayjs(startDate).format('YYYY-MM-DD');
            const expirationDate = dayjs(endDate).format('YYYY-MM-DD');
            const todayFormatted = today.format('YYYY-MM-DD');

            return (
                expirationDate >= todayFormatted && todayFormatted <= beginDate
            );
        };

        return {
            bonusIsActive,
        };
    },
};
</script>
